import { SolutionViewMode } from './Solution.component';

export const adjustLayout_dangerously = (mode: SolutionViewMode, navigationBar: number): void => {
  const commentsBar = document.getElementById('commentsBar');
  const navigationBarDiv = document.getElementById('navigationBar');
  const scoringRulesBar = document.getElementById('scoringRulesBar');
  const annoAndCommBar = document.getElementById('annoAndCommBar');
  if (mode === SolutionViewMode.assessmentSampleAssessmentGroup) {
    const contextualHelp12 = document.getElementById('contextualHelp-12');
    if (navigationBarDiv && contextualHelp12) {
      contextualHelp12.style.top = '-10px';
    }

    const contextualHelp15 = document.getElementById('contextualHelp-15');
    if (scoringRulesBar && contextualHelp15 && navigationBarDiv && contextualHelp12) {
      contextualHelp15.style.left = navigationBarDiv.offsetWidth + scoringRulesBar.offsetWidth / 2 + 'px';
      contextualHelp15.style.top = contextualHelp12.style.top;
    }

    const contextualHelp14 = document.getElementById('contextualHelp-14');
    if (contextualHelp14) {
      contextualHelp14.style.top = '184px';
      contextualHelp14.style.left = '-4px';
    }

    const contextualHelp16 = document.getElementById('contextualHelp-16');
    if (contextualHelp16 && scoringRulesBar && navigationBarDiv) {
      contextualHelp16.style.top = (scoringRulesBar.offsetHeight - contextualHelp16.offsetHeight) / 2 + 10 + 'px';
      contextualHelp16.style.left = navigationBarDiv.offsetWidth + (scoringRulesBar.offsetWidth * 3) / 4 + 'px';
    }

    const contextualHelp13 = document.getElementById('contextualHelp-13');
    if (commentsBar && contextualHelp13) {
      contextualHelp13.style.top = commentsBar.offsetHeight + 'px';
      contextualHelp13.style.left = commentsBar.offsetWidth - contextualHelp13.offsetWidth - 20 + 'px';
    }

    const contextualHelp18 = document.getElementById('contextualHelp-18');
    if (annoAndCommBar && contextualHelp18 && navigationBarDiv) {
      contextualHelp18.style.top = annoAndCommBar.offsetHeight + 40 + 'px';
      contextualHelp18.style.left = navigationBarDiv.offsetWidth + annoAndCommBar.offsetWidth - 20 + 'px';
    }
  } else if (mode === SolutionViewMode.sampleAssessmentGroupAssignment) {
    const contextualHelp9 = document.getElementById('contextualHelp-9');
    if (contextualHelp9 && navigationBarDiv) {
      contextualHelp9.style.top = '-10px';
    }
  } else {
    const contextualHelp1 = document.getElementById('contextualHelp-1');
    if (navigationBar && contextualHelp1) {
      contextualHelp1.style.top = '-10px';
    }

    const contextualHelp4 = document.getElementById('contextualHelp-4');
    if (scoringRulesBar && contextualHelp4 && navigationBarDiv && contextualHelp1) {
      contextualHelp4.style.left = navigationBarDiv.offsetWidth + scoringRulesBar.offsetWidth / 2 + 'px';
      contextualHelp4.style.top = contextualHelp1.style.top;
    }

    const contextualHelp3 = document.getElementById('contextualHelp-3');
    if (contextualHelp3) {
      contextualHelp3.style.top = '184px';
      contextualHelp3.style.left = '-4px';
    }

    const contextualHelp5 = document.getElementById('contextualHelp-5');
    if (contextualHelp5 && scoringRulesBar && navigationBarDiv) {
      contextualHelp5.style.top = (scoringRulesBar.offsetHeight - contextualHelp5.offsetHeight) / 2 + 10 + 'px';
      contextualHelp5.style.left = navigationBarDiv.offsetWidth + (scoringRulesBar.offsetWidth * 3) / 4 + 'px';
    }

    const contextualHelp2 = document.getElementById('contextualHelp-2');
    if (commentsBar && contextualHelp2) {
      contextualHelp2.style.top = commentsBar.offsetHeight + 'px';
      contextualHelp2.style.left = commentsBar.offsetWidth - contextualHelp2.offsetWidth - 20 + 'px';
    }

    const contextualHelp17 = document.getElementById('contextualHelp-17');
    if (annoAndCommBar && contextualHelp17 && navigationBarDiv) {
      contextualHelp17.style.top = annoAndCommBar.offsetHeight + 40 + 'px';
      contextualHelp17.style.left = navigationBarDiv.offsetWidth + annoAndCommBar.offsetWidth - 20 + 'px';
    }
  }
};
